import type {
    PlainSearchParameters,
    SearchParameters,
} from "algoliasearch-helper";
import { getAllFiltersString } from "@/services/algoliaRouting.blade";

/**
 * Vehicle/Index curated parity: Vue binds `<ais-configure :filters.camel="rangeFilters" />`
 * where `rangeFilters` is a computed calling `getAllFiltersString()` on every render.
 *
 * A static `configure({ hitsPerPage })` widget merges after routing and wipes
 * `configure.filters`, which causes hydration to refetch all vehicles (103 vs 3).
 * This widget re-injects filters on every search via `getWidgetSearchParameters`.
 */
export function createCuratedConfigureWidget(hitsPerPage: number) {
    return {
        $$type: "custom.curatedConfigure",
        $$widgetType: "custom.curatedConfigure",

        init() {},

        getWidgetSearchParameters(searchParameters: SearchParameters) {
            const filters = getAllFiltersString();

            // Algolia v5 client typings omit API params still supported at runtime.
            const params = {
                hitsPerPage,
                maxValuesPerFacet: 500,
                filters: filters || undefined,
            } as PlainSearchParameters;

            return searchParameters.setQueryParameters(params);
        },

        getWidgetUiState() {
            return {};
        },

        getWidgetRenderState(
            _renderState: Record<string, never>,
            renderOptions: { widgetParams: Record<string, unknown> },
        ) {
            return { widgetParams: renderOptions.widgetParams };
        },

        render() {},
        dispose() {},
    };
}
